import React, { useEffect, useState, useRef } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import s from './EmblaCarousel.module.scss';
import classNames from 'classnames';

const EmblaCarousel = ({
  children,
  onSlideChange,
  options = {},
  setApi,
  modifiers = [],
  autoHeight = false,
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const rootRef = useRef(null);
  const [height, setHeight] = useState('auto');

  const updateHeight = () => {
    if (!emblaApi) return;
    const selectedIndex = emblaApi.selectedScrollSnap();
    const slideNode = emblaApi.slideNodes()[selectedIndex];

    if (slideNode) {
      const newHeight = slideNode.offsetHeight;
      setHeight(newHeight);
    }
  };

  useEffect(() => {
    if (!emblaApi) return;
    if (setApi) setApi(emblaApi);

    const handleSelect = () => {
      onSlideChange?.(emblaApi.selectedScrollSnap());
      if (autoHeight) updateHeight();
    };

    handleSelect();
    emblaApi.on('select', handleSelect);

    if (autoHeight) {
      requestAnimationFrame(() => updateHeight());
      emblaApi.on('resize', updateHeight);
    }

    return () => {
      emblaApi.off('select', handleSelect);
      if (autoHeight) emblaApi.off('resize', updateHeight);
    };
  }, [emblaApi, autoHeight]);

  const classes = classNames(
    s.Root,
    modifiers.map((m) => s[m])
  );

  return (
    <div
      className={classes}
      ref={(node) => {
        rootRef.current = node;
        emblaRef(node);
      }}
      style={autoHeight ? { height } : undefined}>
      <div className={s.Container}>
        {React.Children.map(children, (child) => (
          <div className={s.Slide}>{child}</div>
        ))}
      </div>
    </div>
  );
};

export default EmblaCarousel;
